import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";

const conditions = [
  { name: "Migraine & headaches", desc: "Recurrent migraines, tension headaches, cluster headaches." },
  { name: "PCOS & hormonal balance", desc: "Menstrual irregularities, hormonal acne, thyroid issues." },
  { name: "Anxiety & sleep", desc: "Anxiety, panic, depression, insomnia and stress-related fatigue." },
  { name: "Skin disorders", desc: "Eczema, psoriasis, urticaria, vitiligo and chronic acne." },
  { name: "Respiratory care", desc: "Asthma, allergies, sinusitis, chronic cough and bronchitis." },
  { name: "Paediatric homeopathy", desc: "Recurrent infections, behavioural concerns, growth issues." },
  { name: "Digestive disorders", desc: "IBS, acidity, ulcerative colitis, chronic constipation." },
  { name: "Joint & arthritis", desc: "Rheumatoid arthritis, osteoarthritis, fibromyalgia." },
];

export default function Conditions() {
  return (
    <div>
      <MarketingHeader />
      <section className="max-w-6xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[color:var(--muted)] mb-3">Conditions treated</p>
        <h1 className="font-heading text-4xl md:text-6xl font-light tracking-tight mb-4">A homeopathic approach for whole-body care.</h1>
        <p className="text-[color:var(--muted)] max-w-2xl text-base leading-relaxed mb-12">
          Our practice serves patients across all life stages, from paediatric to geriatric care.
          Each condition is treated with individualisation — your medicine is for you alone.
        </p>
        <div className="grid md:grid-cols-2 gap-5">
          {conditions.map((c) => (
            <div key={c.name} className="bg-white border border-[color:var(--border)] rounded-2xl p-6 hover:shadow-lg transition-shadow" data-testid={`condition-${c.name.toLowerCase().replace(/[^a-z]+/g,'-')}`}>
              <h3 className="font-heading text-xl text-[color:var(--ink)] font-medium">{c.name}</h3>
              <p className="text-sm text-[color:var(--muted)] mt-2 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
